import { Subject } from '~/tutor-on-demand/types/tutor-on-demand.types'
import ROUTES from '~/shared/constants/routes.const'

export const subjects = [
  {
    name: Subject.MATH,
    href: ROUTES.TUTOR_ON_DEMAND_MATH,
    icon: 'mentor-on-demand/icons/math-black-light.svg',
  },
  {
    name: Subject.BIOLOGY,
    href: ROUTES.TUTOR_ON_DEMAND_BIOLOGY,
    icon: 'mentor-on-demand/icons/biology-black-light.svg',
  },
  {
    name: Subject.CHEMISTRY,
    href: ROUTES.TUTOR_ON_DEMAND_CHEMISTRY,
    icon: 'mentor-on-demand/icons/chemistry-black-light.svg',
  },
  {
    name: Subject.ECONOMY,
    href: ROUTES.TUTOR_ON_DEMAND_ECONOMY,
    icon: 'mentor-on-demand/icons/economy-black-light.svg',
  },
  {
    name: Subject.FINANCE,
    href: ROUTES.TUTOR_ON_DEMAND_FINANCE,
    icon: 'mentor-on-demand/icons/finance-black-light.svg',
  },
  {
    name: Subject.PHYSICS,
    href: ROUTES.TUTOR_ON_DEMAND_PHYSICS,
    icon: 'mentor-on-demand/icons/physics-black-light.svg',
  },
  {
    name: Subject.STATISTICS,
    href: ROUTES.TUTOR_ON_DEMAND_STATISTICS,
    icon: 'mentor-on-demand/icons/statistics-v2-black-light.svg',
  },
  {
    name: Subject.OTHER_SUBJECTS,
    href: ROUTES.TUTOR_ON_DEMAND_OTHER_SUBJECTS,
    icon: 'mentor-on-demand/icons/other-subjects-black-light.svg',
  },
] as const
